export default class Collapsable {
  constructor(el) {
    this.el = el;
    if(this.el.dataset.collapsableLoaded){
      return;
    }
    this.el.addEventListener("click", this.toggleCollapse.bind(this));
    this.el.dataset.collapsableLoaded = true;
  }

  toggleCollapse(e) {
    const el = e.currentTarget;
    if (el.matches('a[href="#"]')) {
      e.preventDefault();
    }
    const toCollapse = this.getCollapsableElement();
    if (toCollapse) {
      if (this.isVisible(toCollapse)) {
        this.hide(toCollapse);
        if (el.dataset.hasOwnProperty("collapsableOpened")) {
          delete el.dataset.collapsableOpened;
        }
      } else {
        this.show(toCollapse);
        el.dataset.collapsableOpened = "";
      }
    }
  }

  hide(el) {
    el.dataset.collapsable = "hidden";
  }

  show(el) {
    el.dataset.collapsable = "visible";
  }

  getCollapsableElement() {
    if (
      this.el.nextElementSibling &&
      this.el.nextElementSibling.dataset.hasOwnProperty("collapsable")
    ) {
      return this.el.nextElementSibling;
    } else if (this.el.dataset.collapsableTarget) {
      return document.querySelector(this.el.dataset.collapsableTarget);
    }
    return null;
  }

  isVisible(el) {
    var style = window.getComputedStyle(el);
    return (
      el.offsetHeight !== 0 &&
      el.offsetWidth !== 0 &&
      style.opacity !== "0" &&
      style.display !== "none" &&
      style.visibility !== "hidden"
    );
  }
}
